module.exports = __webpack_public_path__ + "img/join-us-flow.b7fa0968.svg";